import { TCountryId } from '@/src/components/sarComponent';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CountryState {
  countryId: TCountryId | undefined;
  setCountryId: (id: TCountryId) => void;
}

export const useCountryStore = create<CountryState>()(
  persist(
    (set) => ({
      countryId: undefined,
      setCountryId: (id) => set({ countryId: id }),
    }),
    {
      name: 'country-storage',
    },
  ),
);
